import { render, staticRenderFns } from "./UploadParametrizacao.vue?vue&type=template&id=b0b949d0"
import script from "./UploadParametrizacao.vue?vue&type=script&lang=js"
export * from "./UploadParametrizacao.vue?vue&type=script&lang=js"
import style0 from "./UploadParametrizacao.vue?vue&type=style&index=0&id=b0b949d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports